<template>
  <el-dialog
    top="5vh"
    :title="title"
    :width="width"
    :visible.sync="visible"
    :show="show"
    :append-to-body="appendToBody"
    :close-on-click-modal="false"
    @close="handleClose">
    <slot></slot>
    <span
      v-if="showDialogFooter"
      slot="footer"
      class="dialog-footer">
      <el-button
        v-if="showConfirmButton"
        type="primary"
        :loading.sync="loading"
        @click="handleConfirmButton">
        {{ save }}
      </el-button>
      <el-button v-if="showCancelButton" @click="visible = false">
        {{ cancel }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CustomDialog',
  props: {
    title: { // Dialog 的标题
      type: String,
      default: ''
    },
    width: { // Dialog 的宽度
      type: String,
      default: ''
    },
    show: { // 是否显示 Dialog
      type: Boolean,
      default: false
    },
    appendToBody: { // Dialog 自身是否插入至 body 元素上
      type: Boolean,
      default: false
    },
    showDialogFooter: { // 是否显示 Dialog 按钮操作区的内容
      type: Boolean,
      default: true
    },
    showConfirmButton: { // 是否显示确定按钮
      type: Boolean,
      default: true
    },
    showCancelButton: { // 是否显示取消按钮
      type: Boolean,
      default: true
    },
    loading: { // 是否提交中状态
      type: Boolean,
      default: false
    }
    // confirmButtonText: { // 确定按钮的文本内容
    //   type: String,
    //   default: '保 存'
    // },
    // cancelButtonText: { // 取消按钮的文本内容
    //   type: String,
    //   default: '取 消'
    // }
  },
  data() {
    return {
      visible: this.show, // 是否显示 Dialog
      save: this.$t('save'),
      cancel: this.$t('cancel')
    };
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        this.visible = this.show;
      }
    }
  },
  methods: {
    // Dialog 关闭回调
    handleClose() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    // 点击确认按钮
    handleConfirmButton() {
      this.$emit('confirm');
    }
  }
};
</script>

<style lang="scss">
.el-dialog__body {
  max-height: 510px;
  padding-top: 12px;
  padding-bottom: 15px;
  overflow: auto;
}
</style>